import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadPackageComponent } from './upload-package/upload-package.component';
import { ManagePackageComponent } from './manage-package/manage-package.component';
// import { BundleSpecComponent } from './bundle-spec/bundle-spec.component';
import { Routes, RouterModule } from '@angular/router';
import { PackagesComponent } from './packages.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// Material
import {
	MatInputModule,
	MatPaginatorModule,
	MatProgressSpinnerModule,
	MatSortModule,
	MatTableModule,
	MatSelectModule,
	MatMenuModule,
	MatProgressBarModule,
	MatButtonModule,
	MatCheckboxModule,
	MatDialogModule,
	MatTabsModule,
	MatNativeDateModule,
	MatCardModule,
	MatRadioModule,
	MatIconModule,
	MatDatepickerModule,
	MatAutocompleteModule,
	MatSnackBarModule,
	MatTooltipModule,
	MatFormFieldModule,
	MatChipsModule,
	MatDivider,
	MatDividerModule
} from '@angular/material';

import { MaterialPreviewModule } from '../../partials/content/general/material-preview/material-preview.module';
import { PortletModule } from '../../partials/content/general/portlet/portlet.module';
import { CoreModule } from '../../../core/core.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EditFileDialogComponent } from './edit-file-dialog/edit-file-dialog.component';
import { PartialsModule } from '../../partials/partials.module';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { AuthGuardService } from '../../../../app/core/_guard/auth-guard.service';
import { RoleGuardService } from '../../../../app/core/_guard/role-guard.service';
import { BundleSpecComponent } from './bundle-spec/bundle-spec.component';

const routes: Routes = [
	{
		path: '',
		component: PackagesComponent,
		// canActivateChild: [AuthGuardService, RoleGuardService],
		// data: ['sadmin'],
		children: [
			{
				path: '',
				redirectTo: 'upload',
				pathMatch: 'full'
			},
			{
				path: 'upload',
				component: UploadPackageComponent
			},
			{
				path: 'manage',
				component: ManagePackageComponent
			},
			{
				path: 'bundlespec',
				component: BundleSpecComponent
			}
		]
	}
];

@NgModule({
  imports: [
	CommonModule,
	RouterModule.forChild(routes),
	FormsModule,
	CoreModule,
	NgbModule,
	PartialsModule,
	ReactiveFormsModule,
	MatButtonModule,
	MatInputModule,
	MaterialPreviewModule,
	MatFormFieldModule,
	MatCheckboxModule,
	PortletModule,
	MatDialogModule,
	MatChipsModule,
	MatMenuModule,
	MatSelectModule,
	MatTableModule,
	MatDividerModule,
	MatAutocompleteModule,
	MatRadioModule,
	MatIconModule,
	MatNativeDateModule,
	MatProgressBarModule,
	MatDatepickerModule,
	MatCardModule,
	MatPaginatorModule,
	MatSortModule,
	MatProgressSpinnerModule,
	MatSnackBarModule,
	MatTabsModule,
	MatTooltipModule
  ],
  entryComponents: [
	EditFileDialogComponent
  ],
  declarations: [UploadPackageComponent, ManagePackageComponent, PackagesComponent, EditFileDialogComponent, BundleSpecComponent]
})
export class PackagesModule { }
